export interface FooterInstitucional {
  descripcion: string;
  direccion: string;
  email: string;
  web: string;
  rut: string;
  telefono: string;
  financiadorLogo: string;
  ejecutorLogo: string;
  copyright: string;
}

export const footerInstitucional: FooterInstitucional = {
  descripcion: "MásMed Tarapacá - Proyecto CICYT 2024 dedicado a mejorar el capital humano médico en la región de Tarapacá, Chile.",
  direccion: "Av. Arturo Prat Chacón #2120, Iquique, I Región de Tarapacá (Chile)",
  email: "contacto@masmedtarapaca.cl",
  web: "www.masmedtarapaca.cl",
  rut: "77.019.460-K",
  telefono: "+56 57 2870 4162",
  financiadorLogo: "",
  ejecutorLogo: "",
  copyright: "© 2026 MásMed Tarapacá. Todos los derechos reservados.",
};